<template>
  <v-card>
    <v-tabs v-model="tab" centered icons-and-text>
      <v-tabs-slider></v-tabs-slider>

      <v-tab
        :href="`#tab-${tab.title}`"
        v-for="(tab, i) in tabs"
        :key="`tab_` + i"
      >
        {{ tab.title }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        :value="`tab-${tab.title}`"
        v-for="(tab, i) in tabs"
        :key="`tabitem_` + i"
      >
        <v-card flat>
          <v-card-text>
            <v-expansion-panels>
              <v-expansion-panel
                v-for="(panel, index) in tab.panels"
                :key="index"
              >
                <v-expansion-panel-header>{{
                  panel.title
                }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-img :src="panel.image" width="75%" class="mx-auto">
                  </v-img>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  name: "DFSettings",
  data() {
    return {
      tab: "tab-graphics",
      tabs: [
        {
          title: "Game",
          panels: [
            {
              title: "Combat",
              image: "/img/dfsettings/Game-Combat.jpg",
            },
            {
              title: "HitEffects",
              image: "/img/dfsettings/Game-HitEffects.jpg",
            },
            {
              title: "System",
              image: "/img/dfsettings/Game-System.jpg",
            },
          ],
        },
        {
          title: "Keyboard & Mouse",
          panels: [
            {
              title: "Mouse",
              image: "/img/dfsettings/Keyboard-Mouse.jpg",
            },
            {
              title: "GroundVehicleSensitivity",
              image: "/img/dfsettings/Keyboard-GroundVehicleSensitivity.jpg",
            },
            {
              title: "Gunner",
              image: "/img/dfsettings/Keyboard-Gunner.jpg",
            },
            {
              title: "Aircraft",
              image: "/img/dfsettings/Keyboard-Aircraft.jpg",
            },
          ],
        },
        {
          title: "Graphics",
          panels: [
            {
              title: "Display",
              image: "/img/dfsettings/Graphics-Display.jpg",
            },
            {
              title: "Field of View",
              image: "/img/dfsettings/Graphics-FOV.jpg",
            },
            {
              title: "Basic Graphics",
              image: "/img/dfsettings/Graphics-Basic.jpg",
            },
            {
              title: "Advanced Graphics",
              image: "/img/dfsettings/Graphics-Advanced.jpg",
            },
            {
              title: "Super Resolution",
              image: "/img/dfsettings/Graphics-SuperResolution.jpg",
            },
          ],
        },
      ],
    };
  },
});
</script>
